/* global console, document, Excel, Office */
import { SheetComparator } from "../lib/sheetComparator";
import { Helper } from "../lib/helper";
import { Authentication } from "../lib/authentication";
import * as $ from "jquery";

interface WorkbookData {
  [key: string]: any;
}

const state: {
  oldFile?: WorkbookData;
  newFile?: WorkbookData;
  oldFileName?: string;
  newFileName?: string;
  oldSheet?: string;
  newSheet?: string;
} = {};

const helper = new Helper(state);

function compareWorkbooks(isFreeTrial: boolean) {
  Excel.run(async () => {
    try {
      helper.showLoading();
      document.getElementById("results").innerHTML = "";

      const oldSheet = (document.getElementById("oldFileSelect") as HTMLSelectElement).value;
      const newSheet = (document.getElementById("newFileSelect") as HTMLSelectElement).value;

      if (!state.oldFile || !state.newFile) {
        helper.showError({ message: "Please select both an old and new Excel file" });
        return;
      }

      if (!oldSheet || !newSheet) {
        helper.showError({ message: "Please select sheets to compare from both files" });
        return;
      }

      state.oldSheet = oldSheet;
      state.newSheet = newSheet;

      // Access the stored data directly
      const oldSheetData = state.oldFile[oldSheet].data || state.oldFile[oldSheet];
      const newSheetData = state.newFile[newSheet].data || state.newFile[newSheet];

      // Store worksheet references for format preservation
      state.oldWorksheet = state.oldFile[oldSheet].worksheet;
      state.newWorksheet = state.newFile[newSheet].worksheet;
      state.rowLimit = isFreeTrial ? 100 : null;

      const sheetComparator = new SheetComparator(state);

      await sheetComparator.processComparison(oldSheetData, newSheetData);

      // Hide loading indicator
      helper.hideLoading();
    } catch (error) {
      console.error("Error:", error);
      helper.showError({
        message: "An error occurred: " + (error instanceof Error ? error.message : String(error)),
      });
      helper.hideLoading();
    }
  });
}

Office.onReady((info) => {
  if (info.host === Office.HostType.Excel) {
    let authData: any = null;
    const authentication = new Authentication(state);

    // Try auto-login on add-in load
    authData = authentication.autoLogin();

    $("#compareButton").on("click", () => {
      if (authData && authData.success) {
        compareWorkbooks(authData.data.is_free_trial);
      }
      else {
        console.warn("Auth not successful, can't compare workbooks");
      }
    });
    $(".file-input").on("change", helper.handleFileUpload.bind(helper));

    // Prevent form submission from refreshing the page
    $("#loginForm").on("submit", async function (e) {
      e.preventDefault();
      const email = $("#email").val() as string;
      const authentication = new Authentication(state);
      authData = await authentication.login(email);
    });
  }
});
